export const BASE_LABELS = {
  TITLE: 'Аналитика по эксперту',
  NAV: '1L-Baza',
  UNLOCK_TITLE: 'Доступ к 1L-Baza',
  UNLOCK_HINT: 'Введите пароль для просмотра аналитики базы',
  UNLOCK_PASSWORD: 'Пароль',
  UNLOCK_SUBMIT: 'Открыть',
  UNLOCK_ERROR: 'Неверный пароль',
  CONTEXT_NO_BREAKDOWN: 'без разбивки по менеджерам',
  EXPERT: 'Эксперт',
  EXPERT_PLACEHOLDER: 'Выберите эксперта',
  EXPERT_NOT_FOUND: 'Эксперт не найден',
  DATE_FROM: 'С',
  DATE_TO: 'По',
  SUMMARY: 'Общая сводка',
  KEY_METRICS: 'Ключевые метрики',
  DYNAMICS: 'График динамики',
  PRODUCTS: 'Доход по продуктам',
  TOTAL_REVENUE: 'Выручка всего',
  TOTAL_REVENUE_HINT: '1-я линия + база',
  BASE_REVENUE: 'Доход базы',
  BASE_REVENUE_HINT: '= выручка базы',
  FIRST_LINE_REVENUE: 'Доход 1-й линии',
  FIRST_LINE_REVENUE_HINT: 'консультации',
  TOTAL_CHECKS: 'Чеки всего',
  TOTAL_CHECKS_HINT: 'число оплат',
  AVERAGE_CHECK: 'Средний чек',
  AVERAGE_CHECK_HINT: 'выручка ÷ чеки',
  BASE_AVERAGE_HINT: '= выручка ÷ кол-во',
  ACTIVE_DIALOGS: 'Активные диалоги',
  ACTIVE_DIALOGS_HINT: '= все диалоги базы',
  ACTIVE_DIALOGS_UNAVAILABLE: 'диалоги базы ещё не подключены',
  BASE_CHECKS: 'Чеки в базе',
  BASE_CHECKS_HINT: '= общее кол-во чеков',
  LEADS_TO_BASE: 'Лиды 1-я линия → база',
  LEADS_TO_BASE_HINT: 'перешли в базу',
  REVENUE_BY_DAY: 'Выручка базы по дням',
  LEADS_BY_DAY: 'Лиды 1-я линия → база по дням',
  DIALOGS_BY_DAY: 'Все диалоги базы по дням',
  PRODUCT: 'Продукт',
  CATEGORY: 'Категория',
  CHECKS: 'Чеки',
  REVENUE: 'Выручка',
  AVG_CHECK: 'Ср. чек',
  SHARE: 'Доля выручки',
  WORK: 'Работа',
  ADDON: 'Доп',
  OTHER: 'Прочее',
  LOAD_ERROR: 'Ошибка загрузки данных',
  LOAD_EXPERTS_ERROR: 'Не удалось загрузить список экспертов',
  LOAD_REPORT_ERROR: 'Не удалось загрузить отчёт',
  RETRY: 'Повторить',
  EMPTY_PERIOD: 'Нет данных за выбранный период',
  PICK_EXPERT: 'Выберите эксперта и период',
  EMPTY_PRODUCTS: 'Нет продаж по продуктам за период',
  DIALOGS_UNAVAILABLE: 'Данные по диалогам недоступны для этого эксперта',
  DIALOGS_EMPTY: 'За период не было диалогов базы',
  REVENUE_EMPTY: 'За период не было выручки базы',
};

export const REGION_LABELS: Record<'cis' | 'la', string> = {
  cis: 'СНГ',
  la: 'LATAM',
};

export const CURRENCY_SYMBOLS: Record<string, string> = {
  RUB: '₽',
  USD: '$',
  EUR: '€',
  TRY: '₺',
  MXN: 'MX$',
  BRL: 'R$',
};

export type PeriodPreset = '7' | '30' | '60' | '90' | 'all';

export const PERIOD_PRESETS: { value: PeriodPreset; label: string; days?: number }[] = [
  { value: '7', label: '7д', days: 7 },
  { value: '30', label: '30д', days: 30 },
  { value: '60', label: '60д', days: 60 },
  { value: '90', label: '90д', days: 90 },
  { value: 'all', label: 'Всё' },
];
